import api from '../../axiosConfig';

/**
 * Handles the submission of email requests dynamically based on the type of request.
 * @param {string} endpoint - The API endpoint for sending the email.
 * @param {Object} payload - The email payload containing type-specific and user details.
 * @returns {Object} - Response or error object.
 */
export const handleEmailSubmission = async (endpoint, payload) => {
    try {
        // Determine the request type dynamically (Feature Request or Bug Report)
        const isFeatureRequest = payload.featureType !== undefined;
        const isBugReport = payload.bugType !== undefined;

        // Dynamically construct the email body and subject
        const emailBody = isFeatureRequest
            ? `Feature Type: ${payload.featureType}\n\nDescription: ${payload.description}\n\nSubmitted by: ${payload.firstName} ${payload.lastName}\nEmail: ${payload.email}`
            : isBugReport
                ? `Bug Type: ${payload.bugType}\n\nDescription: ${payload.description}\n\nSteps to Reproduce:\n${payload.stepsToReproduce}\n\nSubmitted by: ${payload.firstName} ${payload.lastName}\nEmail: ${payload.email}`
                : `General Request\n\nDetails:\n${JSON.stringify(payload)}`;

        const emailSubject = isFeatureRequest
            ? `[Feature Request] - ${payload.featureType}`
            : isBugReport
                ? `[Bug Report] - ${payload.bugType}`
                : 'General Request Submission';

        // Add the dynamically constructed email body and subject to the payload
        const finalPayload = {
            ...payload,
            subject: emailSubject,
            body: emailBody,
        };

        // Send the email via API
        const response = await api.post(endpoint, finalPayload);

        if (response.status === 200) {
            return { success: true, message: 'Email submitted successfully!' };
        } else {
            return { success: false, message: 'There was an issue submitting your email. Please try again.' };
        }
    } catch (error) {
        console.error('Error submitting email:', error);
        return { success: false, message: 'An error occurred while submitting your email. Please try again later.' };
    }
};
